module.exports = __webpack_public_path__ + "img/icon_bottom_2.75768a05.png";